/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InternalRateOfReturnViewModel } from './InternalRateOfReturnViewModel';
import {
    InternalRateOfReturnViewModelFromJSON,
    InternalRateOfReturnViewModelFromJSONTyped,
    InternalRateOfReturnViewModelToJSON,
} from './InternalRateOfReturnViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfInternalRateOfReturnViewModel
 */
export interface ResultOfInternalRateOfReturnViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfInternalRateOfReturnViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfInternalRateOfReturnViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfInternalRateOfReturnViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfInternalRateOfReturnViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfInternalRateOfReturnViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfInternalRateOfReturnViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfInternalRateOfReturnViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {InternalRateOfReturnViewModel}
     * @memberof ResultOfInternalRateOfReturnViewModel
     */
    data?: InternalRateOfReturnViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfInternalRateOfReturnViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfInternalRateOfReturnViewModel interface.
 */
export function instanceOfResultOfInternalRateOfReturnViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfInternalRateOfReturnViewModelFromJSON(json: any): ResultOfInternalRateOfReturnViewModel {
    return ResultOfInternalRateOfReturnViewModelFromJSONTyped(json, false);
}

export function ResultOfInternalRateOfReturnViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfInternalRateOfReturnViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : InternalRateOfReturnViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfInternalRateOfReturnViewModelToJSON(value?: ResultOfInternalRateOfReturnViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': InternalRateOfReturnViewModelToJSON(value.data),
        'Count': value.count,
    };
}

